import { RebateTypeDto } from './rebate-type.dto';
import { RebateCriteriaTypeDto } from './rebate-criteria-type.dto';
import { RebatePaymentMethodDto } from './rebate-payment-method.dto';
import { RebateSettlementFrequencyDto } from './rebate-settlement-frequency.dto';

export class RebateContextDto {
  rebateTypes: RebateTypeDto[];
  rebateCriteriaTypes: RebateCriteriaTypeDto[];
  rebatePaymentMethods: RebatePaymentMethodDto[];
  rebateSettlementFrequencies: RebateSettlementFrequencyDto[];
}